interface LocationData {
  location: { latitude: string, longitude: string }
}

// this is a business function at the moment because it only considers hotel offers
export function getLocationDataFromOffer(offer: App.AnyOffer): LocationData {
  // not parsing placeid
  // we do not offer bundle_and_save
  switch (offer.type) {
    case 'hotel':
    case 'last_minute_hotel':
    case 'tactical_ao_hotel':
    case 'bedbank_hotel':
    case 'rental':
      return { location: { latitude: offer.property?.latitude.toString() || '', longitude: offer.property?.longitude.toString() || '' } }
    default:
      return { location: { latitude: '', longitude: '' } }
  }
}
